import { Browser, DOMUtils } from '../../../../utils/dom'
import { Mixin } from '../../../../utils/mixin'
import { IAdBiddingAdapter, IAdBiddingProviderConfig } from '../adapter'

export const WithDistrictMExpressBidding = <T extends Mixin<IAdBiddingAdapter>>(Base: T) =>
    class extends Base implements IAdBiddingAdapter {
        private preBiddingExpressDistrictMJsURL = '//hb.districtm.io/prod/100549/all.postmedia.js'

        /**
         * Loads District M JS library.
         */
        public initializeBidding(confs: IAdBiddingProviderConfig[], ...args: any[]) {
            super.initializeBidding(confs, ...args)

            // TODO: remove when DistrictM supports IE 11 (or we don't)
            if (Browser.ie11) {
                return
            }
            DOMUtils.loadScript(`${this.preBiddingExpressDistrictMJsURL}`)
        }
    }
